import React, {createContext, useState} from 'react'
import PropTypes from 'prop-types'
// import {BRAND_INFO as delonghiInfo} from './../../../brand-configuration/delonghi/brand'
// import {BRAND_INFO as kenwoodInfo} from './../../../brand-configuration/kenwood/brand'
// import {BRAND_INFO as nutribulletInfo} from './../../../brand-configuration/nutribullet/brand'
import {BRAND_INFO} from '../brand'
import {noop} from '../utils/utils'

// Create a context with a default value
export const ThemeContext = createContext()

const ThemeProvider = ({children}) => {
    const currentThemeInfo = BRAND_INFO
    const [theme] = useState(currentThemeInfo)

    /*const toggleTheme = () => {
        setTheme((prevTheme) => {
            return prevTheme.key === 'delonghi' ? kenwoodInfo : delonghiInfo
        })
    }*/

    const toggleTheme = () => noop

    return <ThemeContext.Provider value={{theme, toggleTheme}}>{children}</ThemeContext.Provider>
}

export default ThemeProvider

ThemeProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export const useCustomTheme = () => {
    const context = React.useContext(ThemeContext)
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider')
    }
    return context
}
